import * as productAPI from '../api/products'
import {
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_PRICING,
  DELETE_PRODUCT,
  CREATE_BUNDLE,
  UPDATE_BUNDLE,
  REMOVE_BUNDLE_IMAGE,
  DELETE_BUNDLE,
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  CREATE_TAG,
  UPDATE_TAG,
  DELETE_TAG,
  CREATE_ITEM,
  UPDATE_ITEM,
  REMOVE_ITEM_IMAGE,
  DELETE_ITEM,
  CREATE_PRODUCT_PART,
  UPDATE_PRODUCT_PART,
  DELETE_PRODUCT_PART,
  CREATE_PRODUCT_BUNDLE,
  DELETE_PRODUCT_BUNDLE,
  CREATE_PRODUCT_CATEGORY,
  DELETE_PRODUCT_CATEGORY,
  CREATE_PRODUCT_TAG,
  DELETE_PRODUCT_TAG,
  CREATE_PRODUCT_ITEM,
  UPDATE_PRODUCT_ITEM,
  DELETE_PRODUCT_ITEM, UPDATE_PRODUCT_LISTED
} from "../mutation-types"

// initial state
const products = {
  namespace: 'products',
  state: {
    all: [],
    bundles: [],
    categories: [],
    items: [],
    tags: [],
    product_bundles: [],
    product_categories: [],
    product_items: [],
    product_parts: [],
    product_tags: [],
  },
  getters: {
    products: (state) => state.all.sort((a, b) => a.sku.localeCompare(b.sku)),
    bundles: (state) => state.bundles.sort((a, b) => a.name.localeCompare(b.name)),
    categories: (state) => state.categories,
    items: (state) => state.items,
    tags: (state) => state.tags,
    productParts: (state) => state.product_parts,
  },
  mutations: {
    [CREATE_PRODUCT](state, newProduct) {
      state.all.push(newProduct)
    },

    [UPDATE_PRODUCT](state, newProduct) {
      let updateProduct = state.all.find(product => product.id === newProduct.id)
      let index         = state.all.indexOf(updateProduct);

      state.all.splice(index, 1, newProduct)
    },

    [UPDATE_PRODUCT_PRICING](state, newProducts) {
      for (let x = 0; x < newProducts.length; x++) {
        let newProduct    = newProducts[x];
        let updateProduct = state.all.find(product => product.id === newProduct.id)
        let index         = state.all.indexOf(updateProduct);

        state.all.splice(index, 1, newProduct)
      }
    },

    [DELETE_PRODUCT](state, deleteProduct) {
      let product = state.all.find(product => product.id === deleteProduct.id)
      let index   = state.all.indexOf(product);

      // find links associated with product
      let productBundles    = state.product_bundles.filter(productBundle => productBundle.product_id)
      let productCategories = state.product_categories.filter(productCategory => productCategory.product_id)
      let productTags       = state.product_tags.filter(productTag => productTag.product_id)
      let productItems      = state.product_items.filter(productItem => productItem.product_id)
      let productParts      = state.product_parts.filter(productPart => productPart.product_id)

      // delete associated links to product
      for (let productBundle in productBundles) {
        state.product_bundles.splice(state.product_bundles.indexOf(productBundles[productBundle]), 1)
      }
      for (let productCategory in productCategories) {
        state.product_categories.splice(state.product_categories.indexOf(productCategories[productCategory]), 1)
      }
      for (let productTag in productTags) {
        state.product_tags.splice(state.product_tags.indexOf(productTags[productTag]), 1)
      }
      for (let productItem in productItems) {
        state.product_items.splice(state.product_items.indexOf(productItems[productItem]), 1)
      }
      for (let productPart in productParts) {
        state.product_parts.splice(state.product_parts.indexOf(productParts[productPart]), 1)
      }

      // delete product
      state.all.splice(index, 1)
    },

    [CREATE_BUNDLE](state, newBundle) {
      state.bundles.push(newBundle)
    },

    [UPDATE_BUNDLE](state, newBundle) {
      let updateBundle = state.bundles.find(bundle => bundle.id === newBundle.id)
      let index        = state.bundles.indexOf(updateBundle);

      state.bundles.splice(index, 1, newBundle)
    },

    [REMOVE_BUNDLE_IMAGE](state, imageId) {
      let bundles = state.bundles.filter(bundle => bundle.image_id === imageId);
      for (let bundleIndex in bundles) {
        let newBundle   = Object.assign({}, bundles[bundleIndex], { image_id: null })
        let updateIndex = state.bundles.indexOf(bundles[bundleIndex]);

        state.bundles.splice(updateIndex, 1, newBundle)
      }
    },

    [DELETE_BUNDLE](state, targetBundle) {
      let deleteBundle = state.bundles.find(bundle => bundle.id === targetBundle.id)
      let index        = state.bundles.indexOf(deleteBundle);

      // find products associated with bundle
      let productBundles = state.product_bundles.filter(productBundle => productBundle.bundle_id ===
                                                                         targetBundle.id)
      // delete products linked to bundle
      for (let productBundle in productBundles) {
        state.product_bundles.splice(state.product_bundles.indexOf(productBundles[productBundle]), 1)
      }

      state.bundles.splice(index, 1)
    },

    [CREATE_CATEGORY](state, newCategory) {
      state.categories.push(newCategory)
    },

    [UPDATE_CATEGORY](state, newCategory) {
      let updateCategory = state.categories.find(category => category.id === newCategory.id)
      let index          = state.categories.indexOf(updateCategory);

      state.categories.splice(index, 1, newCategory)
    },

    [DELETE_CATEGORY](state, targetCategory) {
      let deleteCategory = state.categories.find(category => category.id === targetCategory.id)
      let index          = state.categories.indexOf(deleteCategory);

      // find products associated with category
      let productCategories = state.product_categories.filter(productCategory => productCategory.category_id ===
                                                                                 targetCategory.id)
      // delete products linked to category
      for (let productCategory in productCategories) {
        state.product_categories.splice(state.product_categories.indexOf(productCategories[productCategory]), 1)
      }

      state.categories.splice(index, 1)
    },

    [CREATE_ITEM](state, newItem) {
      state.items.push(newItem)
    },

    [UPDATE_ITEM](state, newItem) {
      let updateItem = state.items.find(item => item.id === newItem.id)
      let index      = state.items.indexOf(updateItem);

      state.items.splice(index, 1, newItem)
    },

    [REMOVE_ITEM_IMAGE](state, imageId) {
      let items = state.items.filter(item => item.image_id === imageId);
      for (let itemIndex in items) {
        let newItem     = Object.assign({}, items[itemIndex], { image_id: null })
        let updateIndex = state.items.indexOf(items[itemIndex]);

        state.items.splice(updateIndex, 1, newItem)
      }
    },

    [DELETE_ITEM](state, targetItem) {
      let deleteItem = state.items.find(item => item.id === targetItem.id)
      let index      = state.items.indexOf(deleteItem);

      // find products associated with item
      let productItems = state.product_items.filter(productItem => productItem.item_id === targetItem.id)
      // delete products linked to item
      for (let productItem in productItems) {
        state.product_items.splice(state.product_items.indexOf(productItems[productItem]), 1)
      }

      state.items.splice(index, 1)
    },

    [CREATE_TAG](state, newTag) {
      state.tags.push(newTag)
    },

    [UPDATE_TAG](state, newTag) {
      let updateTag = state.tags.find(tag => tag.id === newTag.id)
      let index     = state.tags.indexOf(updateTag);

      state.tags.splice(index, 1, newTag)
    },

    [DELETE_TAG](state, targetTag) {
      let deleteItem = state.tags.find(tag => tag.id === targetTag.id)
      let index      = state.tags.indexOf(deleteItem);

      // find products associated with tag
      let productTags = state.product_tags.filter(productTag => productTag.tag_id === targetTag.id)
      // delete products linked to tag
      for (let productTag in productTags) {
        state.product_tags.splice(state.product_tags.indexOf(productTags[productTag]), 1)
      }

      state.tags.splice(index, 1)
    },

    [CREATE_PRODUCT_BUNDLE](state, productBundle) {
      state.product_bundles.push(productBundle)
    },

    [DELETE_PRODUCT_BUNDLE](state, targetBundle) {
      let target = state.product_bundles.find(find => find.id === targetBundle.id)
      let index  = state.product_bundles.indexOf(target)

      state.product_bundles.splice(index, 1)
    },

    [CREATE_PRODUCT_CATEGORY](state, productCategory) {
      state.product_categories.push(productCategory)
    },

    [DELETE_PRODUCT_CATEGORY](state, targetCategory) {
      let target = state.product_categories.find(find => find.id === targetCategory.id)
      let index  = state.product_categories.indexOf(target)

      state.product_categories.splice(index, 1)
    },

    [CREATE_PRODUCT_ITEM](state, productItem) {
      state.product_items.push(productItem)
    },

    [UPDATE_PRODUCT_ITEM](state, newProductItem) {
      let target = state.product_items.find(find => find.id === newProductItem.id)
      let index  = state.product_items.indexOf(target)

      state.product_items.splice(index, 1, newProductItem)
    },

    [DELETE_PRODUCT_ITEM](state, targetItem) {
      let target = state.product_items.find(find => find.id === targetItem.id)
      let index  = state.product_items.indexOf(target)

      state.product_items.splice(index, 1)
    },

    [CREATE_PRODUCT_TAG](state, productTag) {
      state.product_tags.push(productTag)
    },

    [DELETE_PRODUCT_TAG](state, targetTag) {
      let target = state.product_tags.find(find => find.id === targetTag.id)
      let index  = state.product_tags.indexOf(target)

      state.product_tags.splice(index, 1)
    },

    [CREATE_PRODUCT_PART](state, productPart) {
      state.product_parts.push(productPart)
    },

    [UPDATE_PRODUCT_PART](state, newProductPart) {
      let target = state.product_parts.find(find => find.id === newProductPart.id)
      let index  = state.product_parts.indexOf(target)

      state.product_parts.splice(index, 1, newProductPart)
    },

    [DELETE_PRODUCT_PART](state, targetPart) {
      let target = state.product_parts.find(find => find.id === targetPart.id)
      let index  = state.product_parts.indexOf(target)

      state.product_parts.splice(index, 1)
    },
  },

  actions: {
    [CREATE_PRODUCT]: formClassAction(productAPI.createProduct, CREATE_PRODUCT),
    [UPDATE_PRODUCT]: formClassAction(productAPI.updateProduct, UPDATE_PRODUCT),
    [UPDATE_PRODUCT_LISTED]: formClassAction(productAPI.updateProductListed, UPDATE_PRODUCT),
    [UPDATE_PRODUCT_PRICING]: regularAction(productAPI.updateProductPricing, UPDATE_PRODUCT_PRICING),
    [DELETE_PRODUCT]: regularAction(productAPI.deleteProduct, DELETE_PRODUCT),

    [CREATE_BUNDLE]: formClassAction(productAPI.createBundle, CREATE_BUNDLE),
    [UPDATE_BUNDLE]: formClassAction(productAPI.updateBundle, UPDATE_BUNDLE),
    [DELETE_BUNDLE]: regularAction(productAPI.deleteBundle, DELETE_BUNDLE),

    [CREATE_CATEGORY]: formClassAction(productAPI.createCategory, CREATE_CATEGORY),
    [UPDATE_CATEGORY]: formClassAction(productAPI.updateCategory, UPDATE_CATEGORY),
    [DELETE_CATEGORY]: regularAction(productAPI.deleteCategory, DELETE_CATEGORY),

    [CREATE_ITEM]: formClassAction(productAPI.createItem, CREATE_ITEM),
    [UPDATE_ITEM]: formClassAction(productAPI.updateItem, UPDATE_ITEM),
    [DELETE_ITEM]: regularAction(productAPI.deleteItem, DELETE_ITEM),

    [CREATE_TAG]: formClassAction(productAPI.createTag, CREATE_TAG),
    [UPDATE_TAG]: formClassAction(productAPI.updateTag, UPDATE_TAG),
    [DELETE_TAG]: regularAction(productAPI.deleteTag, DELETE_TAG),

    [CREATE_PRODUCT_BUNDLE]: regularAction(productAPI.createProductBundle, CREATE_PRODUCT_BUNDLE),
    [DELETE_PRODUCT_BUNDLE]: regularAction(productAPI.deleteProductBundle, DELETE_PRODUCT_BUNDLE),

    [CREATE_PRODUCT_CATEGORY]: regularAction(productAPI.createProductCategory, CREATE_PRODUCT_CATEGORY),
    [DELETE_PRODUCT_CATEGORY]: regularAction(productAPI.deleteProductCategory, DELETE_PRODUCT_CATEGORY),

    [CREATE_PRODUCT_ITEM]: regularAction(productAPI.createProductItem, CREATE_PRODUCT_ITEM),
    [UPDATE_PRODUCT_ITEM]: regularAction(productAPI.updateProductItem, UPDATE_PRODUCT_ITEM),
    [DELETE_PRODUCT_ITEM]: regularAction(productAPI.deleteProductItem, DELETE_PRODUCT_ITEM),

    [CREATE_PRODUCT_TAG]: regularAction(productAPI.createProductTag, CREATE_PRODUCT_TAG),
    [DELETE_PRODUCT_TAG]: regularAction(productAPI.deleteProductTag, DELETE_PRODUCT_TAG),

    [CREATE_PRODUCT_PART]: regularAction(productAPI.createProductPart, CREATE_PRODUCT_PART),
    [UPDATE_PRODUCT_PART]: regularAction(productAPI.updateProductPart, UPDATE_PRODUCT_PART),
    [DELETE_PRODUCT_PART]: regularAction(productAPI.deleteProductPart, DELETE_PRODUCT_PART),
  },
};

function formClassAction(apiAction, vuexAction) {
  return ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      apiAction(commit, data.fields, data.hasOwnProperty('showload') ? data.showload : true)
        .then(data => {
          commit(vuexAction, data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        });
    })
  }
}

function regularAction(apiAction, vuexAction) {
  return ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      apiAction(commit, data)
        .then(data => {
          commit(vuexAction, data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        });
    })
  }
}

export default products;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/products/index.js
// module id = 619
// module chunks = 0